// const Pagination = ({ currentPage, totalPages, onPageChange, maxPagesToShow = 5 }) => {

//     const pageNumbers = [];

//     if (totalPages <= maxPagesToShow) {
//         // Show all pages if totalPages is less than 5
//         for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
//     } else {
//         // Sliding window of 5 pages around current page
//         let startPage = currentPage - 2;
//         let endPage = currentPage + 2;

//         // Adjust if startPage < 1
//         if (startPage < 1) {
//             startPage = 1;
//             endPage = 5;
//         }

//         // Adjust if endPage > totalPages
//         if (endPage > totalPages) {
//             endPage = totalPages;
//             startPage = totalPages - 4;
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(i);
//         }
//     }

//     return (
//         <ul className="pagination mb-0">
//             {/* First Page */}
//             <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                 <button className="page-link" onClick={() => onPageChange(1)}>
//                     &laquo;
//                 </button>
//             </li>

//             {/* Previous Page */}
//             <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                 <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>
//                     &lt;
//                 </button>
//             </li>

//             {/* Page Numbers */}
//             {pageNumbers.map((num) => (
//                 <li key={num} className={`page-item ${num === currentPage ? "active" : ""}`}>
//                     <button className="page-link" onClick={() => onPageChange(num)}>
//                         {num}
//                     </button>
//                 </li>
//             ))}

//             {/* Next Page */}
//             <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                 <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>
//                     &gt;
//                 </button>
//             </li>

//             {/* Last Page */}
//             <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                 <button className="page-link" onClick={() => onPageChange(totalPages)}>
//                     &raquo;
//                 </button>
//             </li>
//         </ul>
//     );
// };

// export default Pagination;

import React from "react";

const Pagination = ({
    currentPage,
    totalPages,
    onPageChange
}) => {

    const getPageNumbers = () => {
        const pages = [];

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);

            if (currentPage > 3) {
                pages.push("...");
            }

            const startPage = Math.max(2, currentPage - 1);
            const endPage = Math.min(totalPages - 1, currentPage + 1);

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 2) {
                pages.push("...");
            }

            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <ul className="pagination mb-0">

            {/* Previous */}
            <li
                className={`page-item ${
                    currentPage === 1 ? "disabled" : ""
                }`}
            >
                <button
                    className="page-link"
                    onClick={() =>
                        onPageChange(currentPage - 1)
                    }
                >
                    Previous
                </button>
            </li>

            {/* Page Numbers */}
            {getPageNumbers().map((page, index) =>
                page === "..." ? (
                    <li
                        key={`dots-${index}`}
                        className="page-item disabled"
                    >
                        <span className="page-link">
                            ...
                        </span>
                    </li>
                ) : (
                    <li
                        key={page}
                        className={`page-item ${
                            page === currentPage
                                ? "active"
                                : ""
                        }`}
                    >
                        <button
                            className="page-link"
                            onClick={() =>
                                onPageChange(page)
                            }
                        >
                            {page}
                        </button>
                    </li>
                )
            )}

            {/* Next */}
            <li
                className={`page-item ${
                    currentPage === totalPages
                        ? "disabled"
                        : ""
                }`}
            >
                <button
                    className="page-link"
                    onClick={() =>
                        onPageChange(currentPage + 1)
                    }
                >
                    Next
                </button>
            </li>

        </ul>
    );
};

export default Pagination;